(() => {
  if (document.documentElement.dataset.msInteractionsBound) return;
  document.documentElement.dataset.msInteractionsBound = 'true';
  const refreshScrollLock = () => document.documentElement.classList.toggle('ms-dialog-open', Boolean(document.querySelector('dialog.ms-dialog[open]')));
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-ms-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.msOpen);
      if (dialog instanceof HTMLDialogElement) {
        dialog.showModal();
        dialog.addEventListener('close', refreshScrollLock, { once: true });
        refreshScrollLock();
      }
    }
    const closer = event.target.closest('[data-ms-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('ms-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
})();
